import { formatDateSafe } from '@/utils/dateUtils';
import type { VacationReceiptSource } from '../../models/vacationReceipt.types';

export const SECTION_TITLE = 'Recibos de Férias';
export const SECTION_DESCRIPTION =
    'Documentos de férias assinados. Por enquanto são anexados à mão; quando a assinatura eletrônica entrar, o recibo chega aqui sozinho.';

export const SELF_SECTION_TITLE = 'Meus recibos de férias';
export const SELF_SECTION_DESCRIPTION =
    'Documentos assinados das suas férias. Se faltar algum, procure o DP.';

export const ADD_LABEL = 'Anexar recibo';
export const EMPTY_MESSAGE = 'Nenhum recibo anexado.';
export const LOADING_MESSAGE = 'Carregando recibos...';
export const ERROR_TITLE = 'Não foi possível carregar os recibos';

export const COLUMN_LABELS = {
    file: 'Arquivo',
    reference: 'Período de referência',
    source: 'Origem',
    uploaded: 'Anexado por',
    actions: 'Ações',
} as const;

export const NO_REQUEST_OPTION_LABEL = 'Sem vínculo — período anterior ao sistema';

export const FORM_LABELS = {
    file: 'Arquivo assinado (PDF)',
    request: 'Solicitação de férias',
    linkedHint: 'O período vem da solicitação vinculada.',
    referenceStart: 'Início do período',
    referenceEnd: 'Fim do período',
    note: 'Observação',
    notePlaceholder: 'Ex.: recibo referente ao período aquisitivo 2025/2026.',
    submit: 'Anexar',
    submitting: 'Enviando...',
    cancel: 'Cancelar',
} as const;

export const FORM_FILE_REQUIRED = 'Selecione o arquivo do recibo.';

export const VIEW_LABEL = 'Ver';
export const DELETE_LABEL = 'Excluir';
export const DELETING_LABEL = 'Excluindo...';

export const DELETE_MODAL_TITLE = 'Excluir recibo';
export const DELETE_MODAL_WARNING =
    'O registro e o arquivo serão apagados. Não há como recuperar depois — se precisar do documento de novo, ele terá de ser anexado outra vez.';
export const DELETE_CONFIRM_YES = 'Sim, excluir';
export const DELETE_CONFIRM_NO = 'Cancelar';

export const SOURCE_LABELS: Record<VacationReceiptSource, string> = {
    manual: 'Manual',
    d4sign: 'D4Sign',
};

export const SOURCE_BADGE_CLASSES: Record<VacationReceiptSource, string> = {
    manual: 'bg-gray-100 text-gray-700',
    d4sign: 'bg-green-100 text-green-800',
};

export const NO_COLLABORATOR_MESSAGE =
    'Salve o cadastro do colaborador antes de anexar recibos — o arquivo precisa de um registro ao qual pertencer.';

export const MISSING_SESSION_EMAIL_TITLE = 'Sessão sem e-mail';
export const MISSING_SESSION_EMAIL_DETAIL =
    'Não foi possível identificar quem está anexando. Entre de novo e tente outra vez.';

export const MISSING_COLLABORATOR_EMAIL_TITLE = 'Cadastro sem e-mail';
export const MISSING_COLLABORATOR_EMAIL_DETAIL =
    'Preencha o e-mail do colaborador antes de anexar — sem ele o recibo fica invisível para o dono.';

/** Marca a linha cujo recibo aponta para um pedido — é o vínculo que a assinatura vai usar. */
export const LINKED_REQUEST_LABEL = 'vinculado à solicitação';

export const NOT_INFORMED = '—';

export function formatReference(startDate: string | null, endDate: string | null): string {
    if (!startDate && !endDate) return NOT_INFORMED;
    if (startDate && endDate) return `${formatDateSafe(startDate)} a ${formatDateSafe(endDate)}`;
    return formatDateSafe(startDate ?? endDate);
}

export function formatMoment(value: { toDate?: () => Date } | null | undefined): string {
    if (!value?.toDate) return NOT_INFORMED;
    return formatDateSafe(value.toDate());
}
